export default {
    manageSettings: 'Manage settings',
    acceptAll: 'Accept all',
    okay: 'Okay',
    acceptSelected: 'Accept selected',
    cancel: 'Cancel',
    bottomNotice: {
        message:
            'Highered is using cookies and certain tracking tools to provide the best possible experience on our website. If you continue to use this site we will assume that you are happy with it.',
    },
    consentModal: {
        topic: 'Privacy & Data',
        title: 'Highered cookie settings',
        intro: 'You can change your preferences at any time',
        privacyPolicy: 'Privacy policy',
        alwaysActive: 'Always active',
        necessarySection: {
            title: 'Strictly necessary cookies',
            shortDescription: 'Helps provide the basics',
            longDescription:
                'These cookies are essential so that you can move around the website and use its features. Without these cookies services you have asked for cannot be provided.',
        },
        analyticsSection: {
            title: 'Analytics',
            shortDescription: 'Helps improve the site',
            longDescription:
                'These cookies collect information about your use of the website and help us to give you better functionality and improve the performance of this website. Consent is stored for a year and can be retracted at any time.',
        },
        outro:
            'We use cookies to ensure that we give you the best experience on our website. We value your privacy. Please let us know if you agree to all of these cookies.',
    },
};
